export const PAYMENT_METHOD_MAP: Record<string, string> = {
  none: 'None',
  credit_card: 'Credit Card',
  ach_credit_transfer: 'ACH',
  ach: 'ACH',
  check: 'Check',
};
